(function () {
    
    const blurbElms = document.querySelectorAll( '.blurb' );

    if ( ! blurbElms ) {
        return;
    }

    blurbElms.forEach((elm) => {
        const itemContainer = elm.querySelector( '.blurb__items' );
        const btnNext = elm.querySelector( '[data-direction="next"]' );
        const btnPrev = elm.querySelector( '[data-direction="prev"]' );
        const scrollAmount = itemContainer.querySelector( ':first-child' ).offsetWidth;
        const controls = elm.querySelector( '.blurb__controls' );

        elm.addEventListener( 'click', (e) => {
            if ( ! [btnNext, btnPrev].includes( e.target ) ) {
                return;
            }

            e.preventDefault();

            if ( e.target === btnNext ) {
                itemContainer.scrollLeft += scrollAmount;
                return;
            }

            itemContainer.scrollLeft -= scrollAmount;
        });

        itemContainer.addEventListener( 'scroll', (e) => {
            const scrollAtEnd = itemContainer.offsetWidth + itemContainer.scrollLeft >= itemContainer.scrollWidth;

            switch ( true ) {
                case itemContainer.scrollLeft === 0:
                    btnPrev.setAttribute( 'disabled', true );
                    btnNext.removeAttribute( 'disabled' );
                    break;

                case scrollAtEnd:
                    btnPrev.removeAttribute( 'disabled' );
                    btnNext.setAttribute( 'disabled', true );
                    break;
                
                case itemContainer.scrollLeft > 0:
                    btnPrev.removeAttribute( 'disabled' );
                    btnNext.removeAttribute( 'disabled' );
                    break;
            }
        });
    })

})();
